module.exports = __webpack_public_path__ + "static/media/zoom-out-white.fbd7e43f.svg";